import {
  MOBILE_BREAKPOINT,
  SMALL_MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from 'src/config-global';
import useResponsive from './useResponsive';

export const useBreakpoints = () => {
  const isSmallMobile = useResponsive('down', SMALL_MOBILE_BREAKPOINT); // down 600
  const upSmallMobile = useResponsive('up', SMALL_MOBILE_BREAKPOINT); // up 600

  const isMobile = useResponsive('down', MOBILE_BREAKPOINT); // down 900
  const upMobile = useResponsive('up', MOBILE_BREAKPOINT); // up 900

  const isTablet = useResponsive(
    'between',
    MOBILE_BREAKPOINT,
    TABLET_BREAKPOINT,
  ); // between 900 and 1200
  const downTablet = useResponsive('down', TABLET_BREAKPOINT); // down 1200
  const upTablet = useResponsive('up', TABLET_BREAKPOINT); // up 1200

  const isDesktop = upTablet;

  return {
    isSmallMobile,
    upSmallMobile,
    isMobile,
    upMobile,
    isTablet,
    downTablet,
    upTablet,
    isDesktop,
  };
};
